import styled from 'styled-components'

import FullScreenModal from '../../../../common/modal/full-screen-modal'

export const GuestPickerModalContainer = styled(FullScreenModal)`
    user-select: none;
`
